import { render, staticRenderFns } from "./UserPersonalCardFilter.vue?vue&type=template&id=61bd9c62&"
import script from "./UserPersonalCardFilter.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports